export default __webpack_public_path__ + "static/media/cross-small.bc7992bf.svg";